import React from "react";

export function GridIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 41.59 18.91"
      fill="white"
      width="30"
      {...props}
    >
      <g id="icons">
        <g id="irq_view_as_grid" data-name="irq view as grid">
          <g>
            <rect
              className="cls-1"
              x="14.62"
              y="0"
              width="12.34"
              height="8.46"
              rx="3"
              ry="3"
            />
            <rect
              className="cls-1"
              x="0"
              y="0"
              width="12.34"
              height="8.46"
              rx="3"
              ry="3"
            />
            <rect
              className="cls-1"
              x="29.25"
              y="0"
              width="12.34"
              height="8.46"
              rx="3"
              ry="3"
            />
            <rect
              className="cls-1"
              x="14.62"
              y="10.45"
              width="12.34"
              height="8.46"
              rx="3"
              ry="3"
            />
            <rect
              className="cls-1"
              y="10.45"
              width="12.34"
              height="8.46"
              rx="3"
              ry="3"
            />
            <rect
              className="cls-1"
              x="29.25"
              y="10.45"
              width="12.34"
              height="8.46"
              rx="3"
              ry="3"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
